import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GreenTickAlt from '../../../assets/image/icons/green_tick_alt.svg';
import CrossCircle from '../../../assets/image/icons/red_x_circle.svg';
import TrophyIcon from '../../../assets/image/icons/tropy-icon.svg';
import { FAIcon, IconStyle } from '../Icons';
import { ProgressStepPropTypes } from './types/propTypes';
import styles from './index.module.scss';


const ProgressStep: FC<ProgressStepPropTypes> = (props: ProgressStepPropTypes) => {
  const {
    isAllWeightIn,
    isAllWeightOut,
    isAllPurchase,
    isAllValidPurchase,
    isAllWin,
    //userName,
    teamName,
    teamEndDate,
    //purchase,
    // weightIn,
    // weightOut,
    // isIndividualAchieved,
    isGroupAchieved,
    handleRedirect,
    //participationType
    isIndividualTeam
  } = props;

  const { t } = useTranslation();

  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');

  // const purchaseStatus = purchase && purchase[0]?.orderStatus ? purchase[0]?.orderStatus : 0;
  // const completedSteps = [
  //   (purchase && purchase.length > 0) || isAllPurchase,
  //   weightIn?.weightInDate || isAllWeightIn,
  //   weightOut?.weightOutDate || isAllWeightOut,
  //   isIndividualAchieved === 1 || isIndividualAchieved === 0 || isGroupAchieved === 1 || isGroupAchieved === 0, //whether win or lose, will skip step 3 and go to 4
  // ].filter(Boolean).length;

  // to show team detail
  const completedSteps = [
    isAllPurchase,
    isAllWeightIn,
    isAllWeightOut,
    isAllWin || (isAllWeightOut && !isAllWin), //whether win or lose
  ].filter(Boolean).length;

  const totalSteps = 4;

  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to midnight to only compare dates

  const isTeamEnded = teamEndDate ? new Date(teamEndDate).getTime() > today.getTime() : false;

  useEffect(() => {
    // if (completedSteps === 4) {
    //   setTitle('Challenge completed');
    //   setMessage('');
    //   if (!isIndividualAchieved || !isGroupAchieved
    //   ){
    //     setMessage("Challenge completed, but didn't meet winning criteria");
    //   }
    // } else if (completedSteps === 0 ){
    //   setTitle('Next step: Team Member Registration');
    //   setMessage('Get your team members to complete their registration and join you in this journey towards better health.');
    // } else if (
    //   (weightIn?.weightInDate !== null && weightOut?.weightOutDate === null) ||  isAllWeightIn
    // ) {
    //   setTitle('Next step: Post-Assessment');
    //   setMessage('Track your journey and progress before your post-assessment.');
    // } else if (
    //   (purchase !== null && purchase !== undefined && purchase.length > 0) || isAllPurchase
    // ) {
    //   setTitle('Next step: Pre-Assessment');
    //   setMessage('Complete your pre-assessment to proceed.');
    // }

    if (isAllWeightIn && isAllWeightOut) {
      setTitle(t('dashboard.home.label.journeyAccomplished'));
      if (isGroupAchieved) {
        setMessage(t('dashboard.home.label.teamSubmittedPostAssessment'));
      } else if (isAllWin) {
        setMessage(t('dashboard.home.label.teamSubmittedPostAssessment'));
      } else {
        setMessage(t('dashboard.home.label.journeyAccomplishedButPostAssessmentNotMeetCriteria'));
      }
    } else if (completedSteps === 0) {
      setTitle(t('dashboard.home.label.nextStepTeamMemberRegistration'));
      setMessage(t('dashboard.home.label.getTeamMemberCompleteRegistration'));
    } else if (isAllWeightIn) {
      setTitle(t('dashboard.home.label.nextStepPostAssessment'));
      setMessage(t('dashboard.home.label.monitorTeamJourneyAndProgress'));
    } else if (isAllPurchase) {
      setTitle(t('dashboard.home.label.nextStepPreAssessment'));
      setMessage(t('dashboard.home.label.ensureTeamPreAssessmentIsCompleted'));
    } else if (isTeamEnded && !isAllWeightOut) {
      setTitle(t('dashboard.home.label.incompleteJourney'));
      setMessage(t('dashboard.home.label.journeyWasNotCompleted'));
    }
  }, [isAllPurchase, isAllPurchase, isAllWeightIn, isAllWeightOut, isAllValidPurchase]);
  return (
    <section className={styles['card-container']} onClick={handleRedirect ? handleRedirect : undefined}>
      <div className={styles['profile-progress-team-name']}>
        {isIndividualTeam === 1 ? (
          <FAIcon iconName={'user'} title={'Individual'} iconStyle={IconStyle.SOLID}/>
        ) : (
          <FAIcon iconName={'users'} title={'Team'} iconStyle={IconStyle.SOLID}/>
        )}&nbsp;&nbsp;
        {teamName}
      </div>
      {/* profile progress and status  */}
      <div className={styles['profile-progress-container']}>
        {/* top */}
        <div className={styles['profile-progress-top']}>
          <div className={styles['icon-container']}>
            <img
              src={completedSteps === 4 ? TrophyIcon : completedSteps === 0 ? CrossCircle : GreenTickAlt}
              alt={completedSteps === 4 ? 'Trophy Icon' : completedSteps === 0 ? 'Cross Circle' : 'Green Tick'}
              width={'23px'}
              height={'23px'}
            />
          </div>
          <div className={styles['label-container']}>
            <div className={styles['title']}>{title}</div>
            <div className={`${styles['sub-title']} ${styles['font-grey']}`}>{message}</div>
          </div>
        </div>
        {/* bottom  */}
        <div className={styles['profile-progress-bottom']}>
          <div className={`${styles['steps']}`}>
            {t('dashboard.home.label.stepsCompleted')
              .replace('{current-step}', completedSteps.toString())
              .replace('{total-steps}', totalSteps.toString())}
          </div>
          <div
            className={`${styles['progress-bar-container-icon']} ${`${styles['progress-bar-container-icon-five']}`}`}
          >
            {/* purchase */}
            <div className={styles['progress-bar-container-icon-item']}>
              <div
                className={`${styles['single-bar']} ${
                  isAllValidPurchase
                    ? styles['green-color']
                    : isAllPurchase && !isAllValidPurchase
                    ? styles['light-red-color']
                    : styles['red-color']
                }`}
              ></div>
            </div>

            {/* weight in */}
            <div className={styles['progress-bar-container-icon-item']}>
              <div
                className={`${styles['single-bar']} ${isAllWeightIn ? styles['green-color'] : styles['gray-color']}`}
              ></div>
            </div>

            {/* weight out */}
            <div className={styles['progress-bar-container-icon-item']}>
              <div
                className={`${styles['single-bar']} ${isAllWeightOut ? styles['green-color'] : styles['gray-color']}`}
              ></div>
            </div>

            {/* result */}
            <div className={styles['progress-bar-container-icon-item']}>
              <div
                className={`${styles['single-bar']} ${
                  isAllWeightOut ? (isAllWin ? styles['green-color'] : styles['light-red-color']) : styles['gray-color']
                }`}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgressStep;
export type { ProgressStepPropTypes };
